import { Dropdown } from "capitalrx-components-2.0/lib/forms";

import styled from "styled-components";

export const TextDropdown = styled(Dropdown)`
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;

  color: ${(props) => props.theme?.primary_button_color} !important;

  &:hover {
    color: ${(props) => props.theme?.primary_button_color} !important;
  }

  & path {
    fill: ${(props) => props.theme?.primary_button_color} !important;
  }

  & div {
    border: none;
    padding: 0;
    color: ${(props) => props.theme?.primary_button_color} !important;
  }

  & .icon.arrow > .icon-container svg path {
    fill: ${(props) => props.theme?.primary_button_color} !important;
  }

  & .focused:not(.readonly) {
    box-shadow: none;
  }
`;
